/**
 * @file index 工具函数
 */

// eslint-disable-next-line import/no-unassigned-import
import { initTime } from './tokens/time';
initTime(); // auto init time in case tree shaking in vite build

export * from './util';
export * from './format';
export * from './parse';
export * from './tokens/date';
export * from './tokens/day';
export * from './tokens/month';
export * from './tokens/week';
export * from './tokens/year';
export * from './locale';
